import { Extension } from "../../core/extension";
import { trailingParagraphPlugin } from "./trailing-paragraph-plugin";
const defaultConfig = {
    ensureBlank: false,
};
/**
 * Ensure the document always has a paragraph as last node.
 */
export class TrailingParagraphExtension extends Extension {
    constructor(options = defaultConfig) {
        super();
        this.options = options;
    }
    addPlugins(schema, plugins) {
        const { ensureBlank } = this.options;
        return plugins.concat([
            trailingParagraphPlugin(schema.nodes.paragraph, ensureBlank),
        ]);
    }
}
